import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React from "react";

interface Props {
  open: boolean;
  handleClose: () => void;
  onSubmit: () => void;
  object: string;
  loading: boolean;
}

const DeleteDialog: React.FC<Props> = ({
  open,
  handleClose,
  object,
  onSubmit,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{`${object} löschen?`}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Das löschen dieses ${object}'s wird den Auftrageber nicht dauerhaft löschen, da es evtl. verknüpfte daten gibt. Er kann nicht mehr zur erfassung von Testdaten benutzt werden. Wird aber noch in beim filtern von Daten angezeigt.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Abbrechen
        </Button>
        <Button onClick={onSubmit} color="primary" autoFocus disabled={loading}>
          Löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
